import { createContext, useContext, useEffect, useReducer } from "react";
import {
  initialState,
  reducer,
  setBookingAddress,
  setBookingShopVisible,
  setBookingTime,
  setBookingTimeVisible,
  setDetail,
  setLoading,
  setQuery,
  setOption,
  setShopId
} from "./reducer";
import { useGetDetailInfo } from "../../../api/shopItemReserveInfo";
import { useQueryParam } from "../../../hooks";
import { useChangeOrderStatus } from "../../../api/orderReserve";
import Dialog from "../../../publicComponent/Dialog";
import { useTranslation } from "react-i18next";
import useNotice from "../../../hooks/useNotice";
import dayjs from "dayjs";
import { getI18n } from "react-i18next";

const Context = createContext(initialState);

function BookingDetailController() {
  const { state, dispatch } = useBookingDetailContext();
  const { loading, getDetail } = useGetDetailInfo();
  const [id] = useQueryParam("id");
  const { cencelOrder } = useChangeOrderStatus();
  const notice = useNotice();
  const { t } = useTranslation();
  const lang = getI18n().language;

  /**
   * 获取预约详情
   * @returns {Promise<void>}
   */
  const getBookingDetail = async () => {
    let { data } = await getDetail({ infoId: id });
    if (data) {
      if (data.timeList && data.timeList.length > 0) {
        data.timeList.forEach((item) => {
          item.timeList.forEach((child) => {
            let currentTime = dayjs(`${item.day} ${child.bookingTime}`).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            child.disabled = dayjs().isAfter(currentTime);
          });
        });
      }
      // const formatData = Object.assign(
      //   {},
      //   {
      //     ...data,
      //     shopInfoList: data.shopInfoList.map((item) => {
      //       return {
      //         ...item,
      //         shopNameResult: lang === "en" ? item.shopNameEn : item.shopName,
      //       };
      //     }),
      //   }
      // );
      // dispatch(setDetail(formatData));
      dispatch(setDetail(data));
    }
  };

  /** 切换语言改变地址中英文 */
  useEffect(() => {
    if (Object.keys(state.option).length) {
      shopHandle(state.option);
    }
  }, [lang]);

  /**
   * 选择预约预约地址
   * @param option
   */
  const shopHandle = (option) => {
    dispatch(setOption(option));
    dispatch(setShopId(option.shopId))
    dispatch(
      setQuery({
        ...state.query,
        shopId: option.shopId,
        reserveInfoId: id,
      })
    );

    const areaStrArr = option.areaname.split(",")
    dispatch(
      setBookingAddress(
        // `${option.areaname}${lang === "en" ? option.addressEn : option.address}`
        `${t(areaStrArr[0])}${t(areaStrArr[1])}${t(areaStrArr[2])}${lang === "en" ? option.addressEn : option.address}`
      )
    );
  };

  /**
   * 打开关闭预约时间modal
   * @param visible
   */
  const bookingTimeModalHandle = (visible) => {
    dispatch(setBookingTimeVisible(visible));
  };

  const bookingShopModalHandle = (visible) => {
    dispatch(setBookingShopVisible(visible));
  };

  /**
   * 选择预约日期
   * @param option
   */
  const bookingDateHandle = (option) => {
    dispatch(setBookingTime(option.timeList));

    dispatch(
      setQuery({
        ...state.query,
        reserveDate: option.value || option.day,
        reserveTime: "",
      })
    );
  };

  /**
   * 选择预约时间
   * @param time
   */
  const bookingTimeHandle = (time) => {
    dispatch(
      setQuery({
        ...state.query,
        reserveTime: time,
      })
    );
  };

  /**
   * 取消预约
   * @param item
   * @returns {Promise<void>}
   */
  const cancelBooking = async (item) => {
    Dialog.confirm({
      content: t("确定要取消预约吗？"),
      onOk: async (onClose) => {
        let { data } = await cencelOrder({ orderId: item.orderId, status: 3 });
        onClose();
        if (data) {
          notice.success(t("操作成功"));
          getBookingList({ page: 1 });
        }
      },
    });
  };

  /**
   * 返回预约状态字段
   * @param status
   * @returns {string}
   */
  const getStatus = (status) => {
    switch (status) {
      case "0":
        return "待审核";
      case "1":
        return "通过";
      case "2":
        return "不通过";
      case "3":
        return "已取消";
      case "4":
        return "已完成";
      default:
        return "未知状态";
    }
    return "全部"; // status === false
  };

  useEffect(() => {
    if (dispatch) dispatch(setLoading(loading));
  }, [loading]);

  return {
    shopHandle,
    getStatus,
    getBookingDetail,
    bookingDateHandle,
    bookingTimeModalHandle,
    bookingTimeHandle,
    cancelBooking,
    bookingShopModalHandle,
  };
}

function useBookingDetailContext() {
  const { state, dispatch } = useContext(Context);

  return { state, dispatch };
}

export { useBookingDetailContext, BookingDetailController };

export default function BookingDetailContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Context.Provider
      value={{ state, dispatch }}
      initialState={initialState}
      reducer={reducer}
    >
      {children}
    </Context.Provider>
  );
}
